/** Coil Configurator API base URL from PIH env. */
const BASE_URL = process.env.REACT_APP_AWS_COIL_CONFIGURATOR_API ?? "";

export const axiosBaseURL = BASE_URL;

/**
 * API path prefix — same pattern as spare-parts `/spareParts`.
 * When BASE_URL already includes `/coilConfigurator`, paths are relative to that root.
 */
export const apiPathPrefix =
  axiosBaseURL && axiosBaseURL.includes("/coilConfigurator") ? "" : "/coilConfigurator";
